import { Deserializable } from '../../deserializable';

/**
 * Used when a user wants to reset its password after clicking email link
 */
export class ConfirmResetPasswordRequestDTO extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    public username: string,
    public newPassword: string,
    public code: string,
    public recaptchaResponse: string
  ) {
    super();
  }
}
